import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import permissionGrantDTO, { PermissionGrantDTO } from '../../../../domain/permission/PermissionGrantDTO'
import { requireAuthContext } from '../../authorization/GlobalAuthContext'
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import PermissionGrantId = com.eidu.sharedlib.entity.permission.PermissionGrantId
import Permission = com.eidu.sharedlib.entity.permission.Permission
import UpdatePermissionGrantRequest = com.eidu.sharedlib.entity.api.permissions.UpdatePermissionGrantRequest
import PermissionGrant = com.eidu.sharedlib.entity.permission.PermissionGrant
import NonEmptySet = com.quickbirdstudios.nonEmptyCollection.set.NonEmptySet
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector

export type UpdatePermissionGrantParameters = {
  id: PermissionGrantId
  userSelector: EntitySelector
  permissions: readonly Permission[]
}

const updatePermissionGrant = async ({
  id,
  userSelector,
  permissions,
}: UpdatePermissionGrantParameters): Promise<PermissionGrantDTO> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants/${id.toString()}`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: serializeToJsonString(
      new UpdatePermissionGrantRequest(new PermissionGrant(userSelector, NonEmptySet.fromArray([...permissions])))
    ),
    method: 'PUT',
  }).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from updatePermissionGrant endpoint`)
    return permissionGrantDTO((await response.json()).document)
  })
}

export default updatePermissionGrant
